import { useTranslation } from "react-i18next";
import { Flame, ThermometerSun } from "lucide-react";

// Full-bleed safety header of the weather card (UAE midday heat).
export const HeatAlert = ({ temp }) => {
  const { t } = useTranslation();
  if (temp === undefined || temp === null || temp < 40) return null;
  const severe = temp >= 45;
  const Icon = severe ? Flame : ThermometerSun;

  return (
    <div
      data-testid="heat-alert"
      className={`flex items-center gap-2.5 px-3 py-2 text-white ${severe ? "bg-red-600" : "bg-amber-600"}`}
    >
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/95">
        <Icon className={`h-4 w-4 ${severe ? "text-red-600" : "text-amber-600"}`} />
      </span>
      <p className="min-w-0 text-sm font-black leading-snug">
        {t(severe ? "weather.heatDanger" : "weather.heatWarning", { temp })}
      </p>
    </div>
  );
};
